export default __webpack_public_path__ + "static/media/icon-pin.59e2e342.svg";